// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3W6Jx","errorLogs":"EditorFooter_errorLogs__b-NAW"};